import React from 'react';
import { reservationCheckoutLink } from 'pages/Event';
import { useNavigate } from 'react-router-dom';

export default function usePayForReservation() {

    const navigate = useNavigate();

    return {
        goToPay: (id, event_id) => navigate(reservationCheckoutLink(id)(event_id))
    }
}